import { createPreviewOverride } from "@/lib/core/client-flags/create-preview-override";

export const useListingContactHelpPreview = createPreviewOverride({
    param: "listingContactHelp",
    key: "listing-contact-help-preview",
    parse: (value) =>
        value === "control" ||
        value === "reassurance" ||
        value === "facts" ||
        value === "off"
            ? value
            : null,
});
